import { render, staticRenderFns } from "./page001.vue?vue&type=template&id=43cbf3a4&scoped=true&"
import script from "./page001.vue?vue&type=script&lang=js&"
export * from "./page001.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cbf3a4",
  null
  
)

export default component.exports